import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Container,
  Input,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetDownloadRequests } from '../api/Downloads';

import DownloadRequestsHeader from '../components/DownloadRequests/Header';
import DownloadRequestsList from '../components/DownloadRequests/List';
import DownloadRequestsFooter from '../components/DownloadRequests/Footer';

import { getVisibleItemsText } from '../helpers';
import { getUserSetting } from '../helpers/Settings';
import {
  handleComponentParams,
  handleURLParams,
} from '../helpers/URLParams';

import Loading from '../components/Loading';
import ErrorBoundary from '../components/ErrorBoundary';

class DownloadRequests extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requests: [],
      search: '',
      status: 'all',
      requestsTotal: 0,
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      loading: true,
    };

    this.searchRef = React.createRef();

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePerPage = this.handleChangePerPage.bind(this);
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.loadDownloadRequests = this.loadDownloadRequests.bind(this);
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'perPage', 'status', 'search'],
      prevProps,
      this.setState.bind(this),
      () => this.loadDownloadRequests(),
      { status: 'all', search: '', perPage: getUserSetting('admin_per_page') || 20 },
    );
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { status } = this.state;

    const queryParams = new URLSearchParams(location.search);

    if (!queryParams.get('status')) {
      handleURLParams({ status }, history);
    }

    handleComponentParams(
      true,
      ['page', 'perPage', 'status', 'search'],
      null,
      this.setState.bind(this),
      () => this.loadDownloadRequests(),
      { status: 'all', search: '', perPage: getUserSetting('admin_per_page') || 20 },
    );
  }

  loadDownloadRequests() {
    const {
      search,
      status,
      page,
      perPage,
    } = this.state;

    this.setState({ loading: true });

    const downloadRequestStatus = status === 'all' ? '' : status;

    APIgetDownloadRequests({
      search,
      status: downloadRequestStatus,
      page,
      per_page: perPage,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          requests: data.data,
          requestsTotal: data.meta.total,
        });
      }
    });
  }

  handleChangePage(page) {
    const { history } = this.props;
    handleURLParams({ page }, history);

    this.setState({ page });
  }

  handleChangePerPage(perPage) {
    const { history } = this.props;
    handleURLParams({ page: 1, perPage }, history);

    this.setState({ page: 1, perPage });
  }

  handleChangeSearch(e) {
    const {
      name,
      value,
    } = e.target;
    const { history } = this.props;

    this.setState({ [name]: value }, () => {
      if (name === 'status') {
        handleURLParams({ [name]: value, page: 1 }, history);
      }
    });
  }

  handleClearSearch(e) {
    e.preventDefault();
    const { history } = this.props;

    this.searchRef.value = '';
    handleURLParams({ search: '', page: 1 }, history);
    this.setState({
      search: '',
      page: 1,
    });
  }

  handleKeyPress(e) {
    const { search } = this.state;
    const { history } = this.props;

    if (e.key === 'Enter') {
      e.preventDefault();
      this.setState({ page: 1 });
      handleURLParams({ search, page: 1 }, history);
    }
  }

  render() {
    const {
      search,
      page,
      perPage,
      requestsTotal,
      loading,
      status,
    } = this.state;
    const { intl, profile } = this.props;

    return (
      <div className="main-content download-requests-content">
        <Container fluid>
          <DownloadRequestsHeader
            profile={profile}
            requestsTotal={requestsTotal}
            requestsVisible={getVisibleItemsText(page, perPage, requestsTotal)}
            loading={loading}
          />
          <div className="content-wrapper">
            <p>
              {intl.formatMessage({ defaultMessage: 'Manage your download requests.' })}
            </p>
          </div>
          <div className="content-wrapper bulk-actions">
            <div className="position-relative inline-search">
              <Label htmlFor="download-request-status" className="mr-2">
                {intl.formatMessage({ defaultMessage: 'Status' })}
              </Label>
              <Input
                type="select"
                className="custom-select"
                id="download-request-status"
                name="status"
                bsSize="sm"
                disabled={loading}
                onChange={this.handleChangeSearch}
                value={status}
              >
                <option value="all">{intl.formatMessage({ defaultMessage: 'all' })}</option>
                <option value="accepted">{intl.formatMessage({ defaultMessage: 'accepted' })}</option>
                <option value="pending">{intl.formatMessage({ defaultMessage: 'pending' })}</option>
                <option value="rejected">{intl.formatMessage({ defaultMessage: 'rejected' })}</option>
              </Input>
              <Input
                id="download-request-search"
                name="search"
                bsSize="sm"
                innerRef={(ref) => { this.searchRef = ref; }}
                placeholder={intl.formatMessage({ defaultMessage: 'Type something and press Enter to search' })}
                disabled={loading}
                onChange={this.handleChangeSearch}
                onKeyUp={this.handleKeyPress}
                value={search}
              />
              {search && (
                <a
                  href="#clear"
                  className="search-clear"
                  onClick={this.handleClearSearch}
                >
                  <i className="fas fa-times" />
                </a>
              )}
            </div>
          </div>
          {loading ? (
            <Loading />
          ) : (
            <div className="content-wrapper">
              <ErrorBoundary>
                <DownloadRequestsList
                  {...this.state}
                  profile={profile}
                  handleChangeOrder={this.handleChangeOrder}
                  loadDownloadRequests={() => {
                    this.loadDownloadRequests();
                  }}
                />
              </ErrorBoundary>
              <ErrorBoundary>
                <DownloadRequestsFooter
                  {...this.state}
                  handleChangePage={this.handleChangePage}
                  handleChangePerPage={this.handleChangePerPage}
                />
              </ErrorBoundary>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

DownloadRequests.propTypes = {
  intl: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(connect(mapStateToProps)(DownloadRequests)));
